module.exports = __webpack_public_path__ + "static/media/06.f750f1e7.jpg";